
import { CheckCircle } from "lucide-react";

const stats = [
  { number: "97%", label: "Success Rate" },
  { number: "80%", label: "First-Time Players" },
  { number: "100%", label: "Commitment" },
];

const Success = () => {
  return (
    <section className="py-8 bg-primary text-primary-foreground my-6">
      <div className="container mx-auto px-6">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold mb-4">Our Track Record</h2>
          <p className="text-primary-foreground/80">
            "We Have Developed A History of Producing Diamonds From Coal"
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center animate-fade-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="text-4xl font-bold mb-2">{stat.number}</div>
              <div className="text-primary-foreground/80">{stat.label}</div>
            </div>
          ))}
        </div>
        <div className="mt-8 text-center">
          <CheckCircle className="h-16 w-16 mx-auto mb-4 text-secondary" />
          <p className="text-lg">
            Your Competition Is Training While You Are Sleeping
          </p>
        </div>
      </div>
    </section>
  );
};

export default Success;
